var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOtpIcon = function SvgOtpIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3332 3.3335V12.6668C13.3332 13.7715 12.4378 14.6668 11.3332 14.6668H4.6665C3.56184 14.6668 2.6665 13.7715 2.6665 12.6668V3.3335C2.6665 2.22883 3.56184 1.3335 4.6665 1.3335H11.3332C12.4378 1.3335 13.3332 2.22883 13.3332 3.3335Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 57496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.3335 6.6665H2.66683C1.93016 6.6665 1.3335 7.26317 1.3335 7.99984C1.3335 8.7365 1.93016 9.33317 2.66683 9.33317H7.3335V6.6665Z",
    fill: "#1F87E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.38623 10.7536C6.38623 11.2676 7.00623 11.5262 7.37156 11.1642L9.9669 8.59356C10.2969 8.26623 10.2969 7.7329 9.9669 7.40556L7.37156 4.8349C7.00623 4.47356 6.38623 4.73223 6.38623 5.24556V10.7536Z",
    fill: "#1F87E5"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOtpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "otp-icon.f8b5b6228a471cae7a2dcd3d2ff317e2.svg";